<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-data-table
                    :fields="fields"
                    :filter="localFilter"
                    :repository="repositories.usuario"
                    :requestParams="requestParams"
                    :tbody-tr-class="rowClass"
                    :reset-table="resetTable"
                    :search-by="localSearchOption"
                    :disabled-button-search="true"
                    :search-table="searchTable"
                    ref="DataTable"
                    sort-by="nome"
                >
                    <template v-slot:cell(cpf)="row">
                        {{ row.value | formatCpf }}
                    </template>

                    <template v-slot:cell(cns)="row">
                        {{ row.value | formatCns }}
                    </template>

                    <template v-slot:filters>
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="localFieldFilter"
                            @keyup.native.enter="handleEnterKey"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-form-select
                                    :options="searchOptions"
                                    class="m-0"
                                    v-model="localSearchOption"
                                />
                            </rkm-input-group-prepend>

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-checkbox
                                        v-model="showNaoRegularizados"
                                    >
                                        Exibir somente cadastros não regularizados
                                    </rkm-form-checkbox>
                                </rkm-input-group-text>

                                <rkm-button
                                    :disabled="localFieldFilter || !disabledButtonSearch ? false : true"
                                    @click="search"
                                    color="primary"
                                    class="btn-search"
                                >
                                    Buscar
                                </rkm-button>
                                <rkm-button
                                    :disabled="!localFieldFilter"
                                    @click="clear"
                                    class="btn-clear"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <template v-if="!$scopedSlots.actions">

                            <rkm-button
                                color="success"
                                title="Ver lotações"
                                @click="$refs.ModalLotacoes.open(item)"
                                small
                            >
                                <rkm-icon icon="hospital-user" />
                            </rkm-button>

                            <rkm-button
                                v-if="!item.bloqueado"
                                authorize="update-cadastro-usuario"
                                color="dark"
                                title="Bloquear usuário"
                                @click="bloquearUsuario(item)"
                                small
                            >
                                <rkm-icon icon="ban" />
                            </rkm-button>

                            <rkm-button
                                v-else
                                authorize="update-cadastro-usuario"
                                color="success"
                                title="Desbloquear usuário"
                                @click="desbloquearUsuario(item)"
                                small
                            >
                                <rkm-icon icon="check-circle" />
                            </rkm-button>

                            <rkm-button
                                authorize="update-cadastro-usuario"
                                color="warning"
                                title="Gerar nova senha"
                                @click="gerarSenha(item)"
                                small
                            >
                                <rkm-icon icon="key" />
                            </rkm-button>

                            <rkm-button
                                @click.stop="$router.push({ name: 'cadastro-usuario-edit', params: { id: item.id } })"
                                color="primary"
                                authorize="update-cadastro-usuario"
                                title="Editar"
                                small
                            >
                                <rkm-icon icon="pen" />
                            </rkm-button>

                            <rkm-button
                                @click.stop="handleDestroy(item)"
                                color="danger"
                                authorize="destroy-cadastro-usuario"
                                title="Excluir"
                                small
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>

                        <slot
                            name="actions"
                            :usuario="item"
                        />
                    </template>
                </rkm-data-table>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col>
                <p class="m-0">
                    Linhas em <span class="danger">vermelho</span> representam pacientes em óbito.
                </p>
            </rkm-col>
        </rkm-row>
        <ModalLotacoes ref="ModalLotacoes" />
    </div>
</template>

<script>
// Components.
import ModalLotacoes from '@/components/cadastro/usuario/components/lotacao/Modal'

// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    components: { ModalLotacoes },
    computed: {
        requestParams() {
            return {
                showNaoRegularizados: this.showNaoRegularizados
            }
        },
        searchOptions() {
            return this.fields.filter(field => !!field.searchable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
    },
    created() {

        this.repositories.usuario = this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')
    },
    data: () => ({
        showNaoRegularizados: false,
        disabledButtonSearch: true,
        localFieldFilter: null,
        localFilter: null,
        localSearchOption: null,
        resetTable: false,
        searchTable: false,
        fields: [
            {
                key: 'nome',
                label: 'Nome',
                name: 'cadastro_cidadao.nome',
                searchable: true,
                sortable: true,
            },
            {
                key: 'cpf',
                label: 'CPF',
                name: 'cadastro_cidadao.cpf',
                searchable: true,
            },
            {
                key: 'cns',
                label: 'CNS',
                name: 'cadastro_cidadao.cns',
                searchable: true,
            },
            {
                class: 'col-min',
                key: 'actions',
                label: 'Ações',
                name: 'actions',
            },
        ],
        repositories: {
            usuario: null,
        },
    }),
    filters: {
        formatCpf: formats.formatCpf,
        formatCns: formats.formatCns,
    },
    methods: {
        bloquearUsuario(item) {

            const bloquear = () => this.repositories.usuario.bloquear(item.id)
                .then(() => this.$refs.DataTable.refresh())

            this.createNotification({
                type: 'dialog',
                color: 'danger',
                title: 'Confirmação de bloqueio',
                message: `Deseja bloquear o usuário ${item.nome}?`,
                confirm: bloquear,
                onError: this.handleError,
            })
        },
        desbloquearUsuario(item) {

            const desbloquear = () => this.repositories.usuario.desbloquear(item.id)
                .then(() => this.$refs.DataTable.refresh())

            this.createNotification({
                type: 'dialog',
                color: 'success',
                title: 'Confirmação de desbloqueio',
                message: `Deseja desbloquear o usuário ${item.nome}?`,
                confirm: desbloquear,
                onError: this.handleError,
            })
        },
        gerarSenha(item) {

            if(item.email){

                const gerarSenha = () => this.repositories.usuario.gerarSenha(item.id)
                    .then(() => {

                        this.showSaveNotification(`Uma nova senha foi enviada para ${item.email}`)
                        this.$refs.DataTable.refresh()
                    })

                this.createNotification({
                    type: 'dialog',
                    color: 'success',
                    title: 'Confirmação de geração de senha',
                    message: `Deseja gerar uma nova senha automaticamente para o usuário ${item.nome}?`,
                    confirm: gerarSenha,
                    onError: this.handleError,
                })

            } else {

                this.showAlert(`Usuário(a) <strong>${item.nome}</strong> não possui email cadastrado para receber uma nova senha.`
                    + ` Cadastre um email para continuar.`)
            }
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.usuario.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o usuário?', destroy, this.handleError)
        },
        rowClass(item, type) {
            if(item && type === 'row') {
                if (item.obito) {
                    return 'table-danger'
                }
            }
        },
        search() {

            this.searchTable = true
            this.resetTable = false
            this.localFilter = this.localFieldFilter
            this.$refs.DataTable.refresh();
        },
        clear() {
            this.localSearchOption = this.searchBy || this.searchOptions[0].value;
            this.clearSearchOption()
        },
        clearSearchOption() {
            this.localFieldFilter = null
            this.showNaoRegularizados = false
            this.clearTable()
        },
        clearTable() {
            this.localFilter = null
            this.resetTable = true
            this.searchTable = false
        },
        handleEnterKey(event) {

            if (event.key === 'Enter' && (this.localFieldFilter || !this.disabledButtonSearch)) {
                this.search();
            }
        },
    },
    mounted() {
        if (this.searchOptions.length > 0) {
            this.localSearchOption = this.searchOptions[0].value
        }
    },
    watch: {
        showNaoRegularizados: function () {

            this.clearTable()
        },
        filter(value) {


            this.localFilter = value
        },
        'localSearchOption': function () {

            this.clearSearchOption()
        },
        'localFieldFilter': function (value) {

            this.searchTable = value ? true : false

            this.clearTable()
        },
    },
    mixins: [ repository, error ],
}
</script>

<style scoped>
.danger {
    color: var(--danger);
}
.btn-search {
    border-top-right-radius: 0.25rem!important;
    border-bottom-right-radius: 0.25rem!important;
}
.btn-clear {
    border-top-left-radius: 0.25rem!important;
    border-bottom-left-radius: 0.25rem!important;
}
</style>